<template>
    <div class="search-tree-component">
        <v-input
            v-model="keyWords"
            name="keyWords"
            kind="search"
            :placeholder="placeholder"
            class="search-block"
            @search="firstSearchList"
        ></v-input>
        <v-tree
            v-show="isTree"
            ref="tree"
            :selected="selected"
            :options="treeData"
            :folder-can-select="false"
            :single="isSingle"
            :load-node="true"
            :with-checkbox="true"
            :max-selected="maxSelect"
            :can-create-folder="true"
            :only-folder-id="true"
            :single-expand="false"
            :user-padding="padding"
            :maps="{ value: 'key' }"
            :sync-handler="syncGetDataTree"
            class="search-result-block"
            @change="handleOnchange"
        >
            <template slot-scope="props" slot="label">
                {{ props.options.name }}
            </template>
            <template slot-scope="props" slot="moreBtn">
                <v-spinner v-if="props.loading" status="default">加载中..</v-spinner>
                <a v-else @click="props.emitSyncEvent">加载更多...</a>
            </template>
        </v-tree>
        <div
            v-spinner="inSearchLoading"
            v-on-scrollto.bottom.20="handleScrollBottom"
            v-show="!isTree"
            ref="selectList"
            class="search-result-block"
        >
            <v-spinner size="large"></v-spinner>
            <v-select-list
                v-show="!isTree"
                :value="selectListValue"
                :multiple="!isSingle"
                :options="selectListData"
                @select="selectListSingleChange"
            ></v-select-list>
        </div>
        <div class="button-row">
            <v-button status="primary" class="confirm-button" @click="handleConfirm">
                确定
                <span v-if="!isSingle">({{ selectLength }}/{{ maxSelect }})</span>
            </v-button>
            <v-button @click="handleCancel">
                取消
            </v-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: '搜索'
        },
        tree: {
            type: Boolean,
            default: true
        },
        isShow: {
            type: Boolean,
            default: false
        },
        isSingle: {
            type: Boolean,
            default: false
        },
        listFunction: {
            type: Function,
            default: null
        },
        maxSelect: {
            type: String,
            default: '2'
        },
        selectData: {
            type: Array,
            default: () => {}
        },
        channelIds: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            oldKeyword: '',
            keyWords: '',
            dataMapList: new Map(),
            selected: this.selectData || [],
            selectListValue: [],
            selectListData: [],
            inSearchLoading: true,
            selectListIsSearch: false,
            selectListShowMore: false,
            selectListIndex: 1,
            selectListIsLoading: false
        };
    },
    computed: {
        isTree() {
            return this.tree && !this.selectListIsSearch;
        },
        padding() {
            return this.isSingle ? 0 : -20;
        },
        isSelectNone() {
            return this.selectListIsSearch && this.selectListData.length === 0 && !this.inSearchLoading;
        },
        selectLength() {
            return this.selected.length;
        },
        singleSelected() {
            return this.selected && this.selected[0] && this.selected[0].key;
        },
        treeData() {
            // 只展示具备的通路类型
            const treeObj = {
                4: { name: '微信公众号', key: '1', children: [] },
                5: { name: '微信小程序', key: '2', children: [] },
                2: { name: '企业群', key: '3', children: [] }
            };
            const tree = [];
            this.channelIds.forEach(item => {
                if (treeObj[item]) {
                    tree.push(treeObj[item]);
                }
            });
            return tree;
        }
    },
    watch: {
        keyWords(nextValue) {
            if (nextValue === '') {
                this.selectListIsSearch = false;
                this.oldKeyword = '';
            }
        },
        selectListValue(nextValue) {
            if (!this.isSingle) {
                if (nextValue.length >= Number(this.maxSelect)) {
                    this.selectListData = this.selectListData.map(selectList => {
                        if (nextValue.indexOf(selectList.value) > -1) {
                            return {
                                ...selectList,
                                disabled: false
                            };
                        }
                        return {
                            ...selectList,
                            disabled: true
                        };
                    });
                } else {
                    this.selectListData = this.selectListData.map(selectList => {
                        return {
                            ...selectList,
                            disabled: false
                        };
                    });
                }
                this.selected = nextValue.map(data => {
                    return { key: data && data.key ? data.key : data };
                });
            } else if (nextValue) {
                this.selected = [{ key: nextValue }];
            }
        },
        selectData(nextValue) {
            this.store(nextValue);
            this.setInnerSelect(nextValue);
        }
    },
    created() {
        if (!this.tree) {
            this.getSingleData();
        }
    },
    mounted() {
        this.selectData.forEach(data => {
            if (!this.dataMapList.has(data.key)) {
                this.dataMapList.set(data.key, data);
            }
        });
    },

    methods: {
        setInnerSelect(nextValue) {
            nextValue.forEach(data => {
                if (!this.dataMapList.has(data.key)) {
                    this.dataMapList.set(data.key, data);
                }
            });
            this.selected = nextValue;
            if (!this.isTree) {
                this.selectListValue = this.selected.map(select => {
                    return select && select.key;
                });
            }
        },
        visibleChange(val) {
            if (!val) {
                this.restore();
            }
        },
        store(val) {
            this.oldData = val.slice();
        },
        restore() {
            this.setInnerSelect(this.oldData);
        },
        getSingleData() {
            let defer;
            this.inSearchLoading = true;
            const params = {
                index: this.selectListIndex,
                count: 20,
            };
            this.selectListIsLoading = true;
            if (this.listFunction) {
                defer = this.listFunction(params);
            } else {
                defer = this.$ajax.get('/tp/IMAccessSet/searchBindingOfficial', {
                    params
                });
            }

            defer.then(res => {
                this.selectListIsLoading = false;
                this.inSearchLoading = false;
                if (+res.code === 0) {
                    const resultList = [];
                    this.selectListValue = this.selected.map(select => {
                        return select && select.key;
                    });
                    if (this.isSingle) {
                        this.selectListValue = this.selectListValue && this.selectListValue[0];
                    }
                    res.data.records.forEach(record => {
                        resultList.push({
                            text: record.name,
                            value: record.key
                        });
                        if (!this.dataMapList.has(record.key)) {
                            this.dataMapList.set(record.key, record);
                        }
                    });
                    this.selectListData = this.selectListData.concat(resultList);
                    this.selectListShowMore = this.calcMoreBtn(res.data.index, res.data.count, res.data.total);
                    if (this.selectListShowMore) {
                        this.selectListIndex = +res.data.index + 1;
                    }
                }
            });
        },
        // 点击tree的请求接口
        getTreeData(type, index) {
            const searchParams = {
                type: Number(type),
                index,
                count: 20,
            };
            const defer = this.$ajax.get('/tp/IMAccessSet/getBindingOfficial', {
                params: {
                    ...searchParams
                }
            });
            defer.catch(res => {
                this.$message.error(res.msg || '获取数据失败');
            });
            return defer;
        },
        // 执行获取tree信息的方法
        syncGetDataTree(index, $vm) {
            const orgId = $vm.options.key;
            this.getTreeData(orgId, index)
                .then(res => {
                    const records = res.data.records || [{}];
                    const isEnough = res.data.count * res.data.index >= res.data.total;
                    records.forEach(record => {
                        if (!this.dataMapList.has(record.key)) {
                            this.dataMapList.set(record.key, record);
                        }
                    });
                    $vm.addChild(records);
                    if (isEnough) {
                        $vm.setSynced();
                    }
                    $vm.hideLoading();
                })
                .catch(() => {
                    $vm.hideLoading();
                    $vm.expand = false;
                });
        },
        // 带key值的search方法
        searchKeyWords(key) {
            if (key && !this.selectListIsLoading) {
                if (key !== this.oldKeyword) {
                    this.oldKeyword = key;
                    this.selectListIndex = 1;
                }
                this.selectListIsLoading = true;
                let defer;
                const params = {
                    keyWords: key,
                    index: this.selectListIndex,
                    count: 100,
                };
                if (this.listFunction) {
                    defer = this.listFunction(params, key);
                } else {
                    defer = this.$ajax.get('/tp/IMAccessSet/searchBindingOfficial', {
                        params
                    });
                }

                defer.then(res => {
                    this.selectListIsLoading = false;
                    if (+res.code === 0) {
                        this.selectListIsSearch = true;
                        const resultList = [];
                        this.selectListValue = this.selected.map(select => {
                            return select && select.key;
                        });
                        if (this.isSingle) {
                            this.selectListValue = this.selectListValue && this.selectListValue[0];
                        }
                        res.data.records.forEach(record => {
                            resultList.push({
                                text: record.name,
                                value: record.key
                            });
                            if (!this.dataMapList.has(record.key)) {
                                this.dataMapList.set(record.key, record);
                            }
                        });
                        this.selectListData = this.selectListData.concat(resultList);
                        this.selectListShowMore = this.calcMoreBtn(res.data.index, res.data.count, res.data.total);
                        if (this.selectListShowMore) {
                            this.selectListIndex = res.data.index + 1;
                        }
                    }
                });
            }
        },
        firstSearchList(key) {
            if ((key && !this.selectListIsLoading) || !this.tree) {
                this.$refs.selectList.scrollTop = 0;
                this.selectListIsSearch = true;
                this.inSearchLoading = true;
                if (key !== this.oldKeyword) {
                    this.oldKeyword = key;
                    this.selectListIndex = 1;
                }

                let defer;
                const params = {
                    keyWords: key,
                    index: 1,
                    count: 100,
                };
                if (this.listFunction) {
                    defer = this.listFunction(params, key);
                } else {
                    defer = this.$ajax.get('/tp/IMAccessSet/searchBindingOfficial', {
                        params
                    });
                }
                defer.then(res => {
                    this.inSearchLoading = false;
                    if (+res.code === 0) {
                        const resultList = [];
                        this.selectListValue = this.selected.map(select => {
                            return select && select.key;
                        });
                        if (this.isSingle) {
                            this.selectListValue = this.selectListValue && this.selectListValue[0];
                        }
                        res.data.records.forEach(record => {
                            resultList.push({
                                text: record.name,
                                value: record.key
                            });
                            if (!this.dataMapList.has(record.key)) {
                                this.dataMapList.set(record.key, record);
                            }
                        });

                        this.selectListData = [];
                        this.selectListData = this.selectListData.concat(resultList);
                        this.selectListShowMore = this.calcMoreBtn(res.data.index, res.data.count, res.data.total);
                        if (this.selectListShowMore) {
                            this.selectListIndex = res.data.index + 1;
                        }
                    }
                });
            }
        },
        handleConfirm() {
            const resultArr = this.selected.map(data => data.key);
            this.$emit('handleSave', resultArr, this.dataMapList);
            this.handleCancel();
        },
        handleCancel() {
            console.log('handleCancel', this.selectListData);
            this.$parent.hide();
        },
        handleOnchange(selectArr) {
            const resultSelect = [];
            selectArr.forEach(select => {
                if (select && select.key) {
                    resultSelect.push({ key: select.key });
                } else {
                    resultSelect.push({ key: select });
                }
            });
            this.selected = resultSelect;
        },
        // 计算是否需要展示加载更多
        calcMoreBtn(index, count, total) {
            return index * count < total;
        },
        handleScrollBottom() {
            if (this.selectListShowMore) {
                if (this.selectListIsSearch) {
                    this.searchKeyWords(this.keyWords);
                } else {
                    this.getSingleData();
                }
            }
        },
        selectListSingleChange(select) {
            if (this.isSingle) {
                this.selectListValue = select.value;
            }
        }
    }
};
</script>

<style lang="less">
@import './style.less';
</style>
